export enum PrescriptionStatusEnum {
  Pending = 0,
  Issue = 1,
  Dispense = 2,
  Deleted = 3,
}
